module.exports = __webpack_public_path__ + "img/glow-green-small.2ccc1d42.png";